import { render, staticRenderFns } from "./EditWebhook.vue?vue&type=template&id=c728265c&"
import script from "./EditWebhook.vue?vue&type=script&lang=js&"
export * from "./EditWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports